/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-08 15:30:36
 * @LastEditors: loong
 * @LastEditTime: 2022-09-08 16:50:32
 */
// 通用主体头部组件
const topbar = () => import("../../layout/topbar");
// const AppHeader_main = () =>import ("../../layout/AppHeader_main");
const moonSample_homeHead = () => import("../../layout/AppHeader_main_moonSample_homeHead");
const AppHeader_main_moonSample = () => import("../../layout/AppHeader_main_moonSample");
// 通用底部组件
const AppFooter_moonSample = () => import("../../layout/AppFooter_moonSample");
// 当前路由组件
export default [
	{
		path: "/moonSample",
		name: "moonSample",
		components: {
			// topbar: topbar,
			header: AppHeader_main_moonSample,
			default: () => import('../../views/moonSample/sampleSearch/moonSampleIndex.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
	{
		path: "/moonSampleHome",
		name: "moonSampleHome",
		components: {
			// topbar: topbar,
			header: moonSample_homeHead,
			default: () => import('../../views/moonSample/moonSampleHome.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
	{
		path: "/moonSampleAboutUS",
		name: "moonSampleAboutUS",
		components: {
			// topbar: topbar,
			header: AppHeader_main_moonSample,
			default: () => import('../../views/moonSample/aboutUS/index.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
	{
		path: "/sampleInfoIndex",
		name: "sampleInfoIndex",
		components: {
			// topbar: topbar,
			header: AppHeader_main_moonSample,
			default: () => import('../../views/moonSample/sampleInfo/sampleInfoIndex.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
	{
		path: "/borrowingReturnIndex",
		name: "borrowingReturnIndex",
		components: {
			// topbar: topbar,
			header: AppHeader_main_moonSample,
			default: () => import('../../views/moonSample/borrowingAndReturn/borrowingReturnIndex.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
	{
		path: "/moonSampleHomeInfo",
		name: "moonSampleHomeInfo",
		components: {
			// topbar: topbar,
			header: AppHeader_main_moonSample,
			default: () => import('../../views/moonSample/moonSampleHomeInfo.vue'),
			footer: AppFooter_moonSample,
		},
		meta: {
			requireAuth: false
		},
		props: {
			header: {
				type: '1'
			}
		}
	},
]
